<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2 has-text-centered-mobile">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6 has-text-centered-mobile">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <h2 class="title">Step 3. Complete Entry</h2>

              <ValidationObserver v-slot="{ passes }">
                <form @submit.prevent="passes(submit)">
                  <div class="columns is-multiline">
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showidno"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="South African ID No/Passport"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="South African ID No/Passport"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.idno" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showcontactno"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Mobile Number"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Mobile Number"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.contactno" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <ValidationProvider
                          name="Gym Name"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Gym Name"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input
                              v-if="!event.config.predefinedgyms"
                              v-model="entry.gymname"
                            />
                            <b-select
                              v-if="event.config.predefinedgyms"
                              v-model="entry.gymname"
                            >
                              <option
                                v-for="item in event.config.predefinedgyms"
                                :key="item"
                              >
                                {{ item }}
                              </option>
                            </b-select>
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="entry.entrytype === 'Team'"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Team Name"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Team Name"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.teamname" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showshirttype"
                    >
                      <div class="control">
                        <BaseSelect
                          label="Shirt Type"
                          v-model="entry.meta.shirttype"
                          rules="required"
                        >
                          <option
                            v-for="shirttype in shirttypes"
                            :key="shirttype"
                          >
                            {{ shirttype }}
                          </option>
                        </BaseSelect>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="
                        event.config &&
                        (!event.config.hideshirtoption ||
                          event.config.optionalshirt)
                      "
                    >
                      <div class="control">
                        <SizeSelect
                          label="Shirt Size"
                          v-model="entry.tshirtsize"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.optionalshirt"
                    >
                      <div class="control" style="padding-top: 40px">
                        <b-checkbox v-model="entry.meta.optionalshirt">
                          Add optional shirt (+{{
                            priceFormatter(
                              event.config.optionalshirtcost,
                              event.paymentdetails.currency
                            )
                          }})
                        </b-checkbox>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.showshortsize"
                    >
                      <div class="control">
                        <SizeSelect
                          label="Shorts Size"
                          v-model="entry.pantssize"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.config && event.config.countryflags"
                    >
                      <div class="control">
                        <CountrySelect v-model="entry.country" />
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event._id === '62ded674be1ac5ff6806fb7d'"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Shipping Address"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="T-Shirt Shipping Address"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input
                              type="textarea"
                              v-model="entry.meta.postaladdress"
                            />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.type !== 'online' && event.type !== 'seminar'"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Emergency Contact Name"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Emergency Contact Name"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.emergencycontactname" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="column is-6-desktop"
                      v-if="event.type !== 'online'"
                    >
                      <div class="control">
                        <ValidationProvider
                          name="Emergency Contact Number"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Emergency Contact Number"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="entry.emergencycontactno" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div
                    class="column"
                    v-if="
                      event.config &&
                      event.config.predefineteam &&
                      teammembers &&
                      teammembers.length > 0
                    "
                  >
                    <PredefineTeam
                      :teammembers="teammembers"
                      :teamsize="teamsize"
                      :event="event"
                    />
                  </div>
                  <div class="has-text-centered">
                    <div class="is-block has-text-centered">
                      <button
                        class="button btn-align no-lh raised is-medium primary-btn"
                        type="submit"
                        :disabled="loading"
                        :class="{ 'is-loading': loading }"
                      >
                        Complete Entry
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PredefineTeam from "@/components/PredefineTeam";
import CountrySelect from "@/components/CountrySelect";
import SizeSelect from "@/components/SizeSelect";
import BaseSelect from "@/components/BaseSelect";
import EventEntryApi from "@/api/event-entry";
import filters from "@/filters";
export default {
  mixins: [filters],
  components: {
    PredefineTeam,
    CountrySelect,
    SizeSelect,
    BaseSelect,
  },
  data() {
    return {
      loading: true,
      hideButton: true,
      waitinglist: false,
      registered: false,
      event: {},
      entry: {
        gymname: "",
        entrytype: "",
        category: "",
        meta: {},
      },
      teammembers: [],
      teamsize: 0,
      override: false,
      paid: false,
      prepaid: false,
      invalidreason: "",
      vouchercode: "",
      voucher: {},
      showpaymentbutton: false,
      paymenturl: null,
      currentUser: {},
      // shirttypes: [],
    };
  },
  async created() {
    this.entry = await EventEntryApi.getEventEntry(this.$route.params.id);
    this.getFullUser().then((user) => {
      this.currentUser = user;
      this.setUserDefaults();
    });

    this.event = this.entry.event;

    if (this.event.config && this.event.config.predefineteam) {
      this.teamsize = this.event.config ? this.event.config.teamsize - 1 : 0;
      for (let i = 0; i < this.teamsize; i++) {
        this.teammembers.push({
          firstname: "",
          surname: "",
          email: "",
          gender: "",
        });
      }
    }

    if (
      this.event.config.predefinedgyms &&
      this.event.config.predefinedgyms.length > 0
    ) {
      this.entry.gymname = this.event.config.predefinedgyms[0];
    }

    this.loading = false;
  },
  watch: {
    divisions() {
      if (this.divisions && this.divisions.length > 0) {
        if (this.divisions.length === 1) {
          this.entry.category = this.divisions[0];
          this.changeCategory(this.entry.category);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    shirttypes() {
      if (this.event && this.entry.dependant) {
        const dependant = this.dependants.find(
          (item) => item._id == this.entry.dependant
        );
        if (this.event.config && this.event.config.showshirttype) {
          return this.event.config.shirttypes[dependant.gender];
        }
      } else {
        if (this.event.config && this.event.config.showshirttype) {
          return this.event.config.shirttypes[this.currentUser.gender];
        }
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      "getUser",
      "getEvent",
      "checkVoucher",
      "updateUser",
      "addTeamMember",
      "getFullUser",
    ]),
    priceFormatter(price, currency) {
      let display = "";
      switch (currency) {
        case "ZAR":
          display = `R${price} ZAR`;
          break;
        case "USD":
          display = `$${price} USD`;
          break;
        case "EUR":
          display = `€${price} EUR`;
          break;
        case "GBP":
          display = `£${price} GBP`;
          break;
        case "NAD":
          display = `N$${price} NAD`;
          break;
      }
      return display;
    },

    setUserDefaults() {
      let fields = [
        "country",
        "tshirtsize",
        "pantssize",
        "gymname",
        "emergencycontactno",
        "emergencycontactname",
        "idno",
        "contactno",
      ];
      fields.forEach((field) => {
        this.entry[field] = this.currentUser[field];
      });
    },
    async inviteTeamMembers(newentry) {
      for (let member of this.teammembers) {
        member.event = this.event._id;
        member.evententry = newentry._id;
        member.action = "Invite";
        await this.addTeamMember(member);
      }
    },
    async submit() {
      try {
        this.loading = true;

        if (!this.entry.dependant) {
          let fields = [
            "country",
            "tshirtsize",
            "gymname",
            "pantssize",
            "emergencycontactno",
            "emergencycontactname",
            "idno",
            "contactno",
          ];
          let updateUser = false;
          fields.forEach((field) => {
            if (!updateUser && this.entry[field] !== this.user[field]) {
              this.currentUser[field] = this.entry[field];
              updateUser = true;
            }
          });
          if (updateUser) {
            await this.updateUser(this.currentUser);
            await this.getUser();
          }
        }

        if (this.entry.entrytype === "Team") {
          let result = await EventEntryApi.checkTeamNameExists(
            this.event._id,
            this.entry.teamname
          );
          if (!result.notexists) {
            this.$buefy.toast.open({
              message: "This team name is already registered.",
              position: "is-top",
              type: "is-danger",
            });
            this.loading = false;
            return;
          }
        }

        this.entry.prepaidcomplete = true;
        await EventEntryApi.updateEntry(this.entry);
        await EventEntryApi.sendConfirmationMail(this.entry._id);
        if (
          this.entry.entrytype === "Team" &&
          this.event.config &&
          this.event.config.predefineteam
        ) {
          await this.inviteTeamMembers(newentry);
        }
        this.$buefy.toast.open({
          message: "You've signed up to the event successfully.",
          position: "is-top",
          type: "is-success",
        });
        this.loading = false;
        this.$router.push({
          name: "Home",
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
p {
  margin-bottom: 15px;
}
</style>
